import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import ProductVariantContainer from "./ProductVariant";
import { createAmountMap } from "@configuratorware/configurator-frontendgui/App/Shared/Containers/ProductVariant/ProductVariant";
import { connect } from "react-redux";
import createSelector from "@configuratorware/configurator-frontendgui/Utils/Function/createSelector";
import { Services } from "@configuratorware/configurator-frontendgui/App/ServiceLocator";
import {
  getSelectedAmounts,
  getItem,
  getCalculation,
  getSelectedVariantIdentifier,
  getBulkNames,
  showReceiveOfferForm,
} from "@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors";
import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration";
import getImageUrl from "@configuratorware/configurator-frontendgui/App/Utils/getImageUrl";
import { PMS_REGEX } from "../../../../../lib/constants";

const createAmountData = (
  item,
  selectedAmounts,
  bulkNames,
  selectedVariantIdentifier
) => {
  const restrictAmountselectionToSelectedVariant = getConf(
    "restrictAmountselectionToSelectedVariant",
    false
  );
  if (isEmpty(item)) {
    return [];
  }
  // check if item has children or if the amountData should be created based on the item data
  let amountData;
  if (get(item, "itemGroup.children.length", 0) > 0) {
    amountData = itemGroupMap(item, (colorGroupItem) => ({
      title: "colorGroupItem.itemgroupentryTitle",
      identifier: colorGroupItem.identifier,
      amount: get(selectedAmounts, colorGroupItem.identifier, 0),
      url: getImageUrl(colorGroupItem.thumbnail),
      isDisabled:
        restrictAmountselectionToSelectedVariant &&
        colorGroupItem.identifier !== selectedVariantIdentifier,
      bulkNames: get(bulkNames, colorGroupItem.identifier, []),
      sizes: itemGroupMap(colorGroupItem, (sizeGroupItem) => ({
        size: sizeGroupItem.itemgroupentryTitle,
        bulkNames: get(bulkNames, sizeGroupItem.identifier, []),
        amount: get(selectedAmounts, sizeGroupItem.identifier, 0),
        label: sizeGroupItem.itemgroupentryTitle,
        key: sizeGroupItem.identifier,
        identifier: sizeGroupItem.identifier,
        url: getImageUrl(sizeGroupItem.thumbnail),
      })),
    }));
  } else {
    const itemIdentifier = item && item.identifier;
    amountData = [
      {
        title: item && item.title,
        identifier: itemIdentifier,
        amount: get(selectedAmounts, itemIdentifier, 0),
        url: getImageUrl(item.thumbnail),
        isDisabled:
          restrictAmountselectionToSelectedVariant &&
          item.identifier !== selectedVariantIdentifier,
        bulkNames: get(bulkNames, itemIdentifier, []),
        sizes: [],
        max: 1000,
      },
    ];
  }

  return amountData;
};

export const createPropsFromState = createSelector(
  getItem,
  getSelectedAmounts,
  getBulkNames,
  getCalculation,
  getSelectedVariantIdentifier,
  (
    item,
    selectedAmounts,
    bulkNames,
    selectedVariantIdentifier,
    calculation
  ) => {
    const amountData = createAmountData(
      item,
      selectedAmounts,
      bulkNames,
      selectedVariantIdentifier
    );

    const amountMap = createAmountMap(amountData);

    let error = null;

    if (calculation && calculation.success === false) {
      error = {
        code: calculation.code,
        errors: calculation.errors,
      };
    }

    return {
      error,
      amountData,
      amountMap,
    };
  }
);
const mapStateToProps = (state) => ({
  ...createPropsFromState(state.configurator),
  checkSelectedPMS: (amount) => {
    const {
      userSelectedCalculation,
    } = state.configurator.configuration.customdata;
    const { sortedPmsAmounts } = state.customConfigurator;
    if (userSelectedCalculation) {
      Object.keys(userSelectedCalculation).forEach((key) => {
        if (key.match(PMS_REGEX)) {
          if (userSelectedCalculation[key]) {
            const value = parseFloat(key.split(PMS_REGEX)[1]);
            const idx = sortedPmsAmounts.findIndex(
              (sorted) => sorted.minAmount === value
            );
            if (amount < value) {
              let chosenIdx = idx;
              if (sortedPmsAmounts[0].minAmount > amount) {
                // nothing selected, we are under minamount
                Services.configurator.setSelectedCalculation(
                  sortedPmsAmounts[idx].calculationTypeIdentifier,
                  false
                );
              } else {
                for (let i = idx; i >= 0; i--) {
                  if (sortedPmsAmounts[i].minAmount >= amount) {
                    chosenIdx = i;
                  } else {
                    break;
                  }
                }
                if (chosenIdx !== idx) {
                  Services.configurator.setSelectedCalculation(
                    sortedPmsAmounts[idx].calculationTypeIdentifier,
                    false
                  );
                  Services.configurator.setSelectedCalculation(
                    sortedPmsAmounts[chosenIdx].calculationTypeIdentifier,
                    true
                  );
                }
              }
            } else if (amount > value) {
              let chosenIdx = idx;
              for (let i = idx; i < sortedPmsAmounts.length; i++) {
                if (sortedPmsAmounts[i].minAmount <= amount) {
                  chosenIdx = i;
                } else {
                  break;
                }
              }
              if (chosenIdx !== idx) {
                Services.configurator.setSelectedCalculation(
                  sortedPmsAmounts[idx].calculationTypeIdentifier,
                  false
                );
                Services.configurator.setSelectedCalculation(
                  sortedPmsAmounts[chosenIdx].calculationTypeIdentifier,
                  true
                );
              }
            }
          }
        }
      });
    }
  },
  handleChange: (variant, size, amount) =>
    Services.configurator.setSelectedAmount(
      (size || variant).identifier,
      +amount,
      true
    ),
});
export default connect(mapStateToProps)((props) => {
  return (
    <ProductVariantContainer
      {...props}
      handleChange={(variant, size, amount) => {
        console.log("AAA handlechange");
        props.checkSelectedPMS(amount);
        props.handleChange(variant, size, amount);
      }}
    />
  );
});
